<template>
  <div>
    <site-header></site-header>

    <main :class="$style.fourohfour" class="wrap">
      <h1>Page not found</h1>
      <p>Something seems to have gone wrong.</p>
      <p><router-link to="/">&larr; Back to the homepage</router-link></p>
    </main>
  </div>
</template>

<script>
  import SiteHeader from '../components/SiteHeader';

  export default {
    name: 'home',

    components: {
      SiteHeader,
    },

    head: {
      title() {
        return {
          inner: 'Page not found',
        };
      },
    },
  };
</script>

<style module>
  .fourohfour {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// 404.vue?6e8b3fdc